namespace app.autenticacao {
    "use strict";

    import IStateService = angular.ui.IStateService;
    import MessagesService = app.support.messaging.MessagesService;
    import VersionService = app.autenticacao.VersionService;
    
    class FormLogin {
        public usuario: string;
        public senha: string;
    }
    
    export class LoginController {
    
        public form = new FormLogin();
        
        /** @ngInject **/
        constructor(protected $state: IStateService,
                protected $cookies: ng.cookies.ICookiesService,
                protected $window: ng.IWindowService,
                protected messagesService: MessagesService, 
                protected authService: AuthService,
                protected versionService: VersionService) { 
            Promise.all([this.versionService.getVersionUser(), this.versionService.getVersionServer()])
                .then(([versionUser, versionServer]) => {
                    if (versionUser != versionServer) {
                        this.$window.location.reload();
                    }
            });

            if (!this.isLocal() && (this.isMobile() || this.$window.location.hash)) {
                this.authService.verifyRedirectAndAuthenticate()
                    .then(redirected => {
                        if (redirected) {  
                            const originalUrlRequest = this.$cookies.get("originalUrlRequest");

                            if (!!originalUrlRequest) {
                                this.$cookies.remove("originalUrlRequest");
                                this.$window.location.href = originalUrlRequest;
                            } else {
                                return this.$state.go("app.tarefas.minhas-tarefas");
                            }
                        }
                    });
            }
        }

        public isLocal(): boolean {
            return this.authService.isLocalAuthentication();
        }

        public entrar(): ng.IPromise<any> {
            if (this.isLocal() || !this.isMobile()) {
                return this.authService.authenticate(this.form.usuario, this.form.senha, true).then(() => {
                    const originalUrlRequest = this.$cookies.get("originalUrlRequest");

                    if (!!originalUrlRequest) {
                        this.$cookies.remove("originalUrlRequest");
                        this.$window.location.href = originalUrlRequest;
                    } else {
                        return this.$state.go("app.tarefas.minhas-tarefas");
                    }
                }).catch((erro) => this.tratarErro(erro));
            }
            return this.authService.loginRedirect();
        }
        
        protected tratarErro(error) {
            let msg;
            if (error.data && error.data.error_description) {
                let parser = new DOMParser();
                let dom = parser.parseFromString(error.data.error_description, "text/html");
                msg = dom.body.textContent;
            }
            this.messagesService.error(msg ? msg : "Usuário ou senha inválido(s).");
        }

        private isMobile(): boolean {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
            navigator.maxTouchPoints > 0;
        }
    }
    
    export class LoginControllerDialog extends LoginController {
        
        /** @ngInject **/
        constructor($state: IStateService,
                $cookies: ng.cookies.ICookiesService,
                $window: ng.IWindowService,
                messagesService: MessagesService, 
                authService: AuthService,
                versionService: VersionService,
                private $mdDialog: ng.material.IDialogService,
                private login: string) {
            super($state, $cookies, $window, messagesService, authService, versionService);
            this.form.usuario = login;
        }
        
        public entrar(): ng.IPromise<any> {
            return this.authService.authenticate(this.form.usuario, this.form.senha).then(() => {
                this.$mdDialog.hide();
                this.messagesService.success("Autenticação realizada com sucesso!");
                
                if (this.form.usuario != this.login) {
                    this.$window.location.reload(false);
                }
            }).catch((erro) => this.tratarErro(erro));
        }
        
        public fechar(): void {
            this.$mdDialog.cancel();
        }
    }

    angular.module("app.login")
        .controller("app.login.LoginController", LoginController)
        .controller("app.login.LoginControllerDialog", LoginControllerDialog);
}